/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentWalletMinimalAmountApiModel } from './payment-wallet-minimal-amount';
import { PaymentWalletFeeApiModel } from './payment-wallet-fee';
import { MobileAppPaymentSettingsScopeApiModel } from './mobile-app-payment-settings-scope';
import { PaymentWalletCardsApiModel } from './payment-wallet-cards';
import { LoyaltyApiModel } from './loyalty';
import { MobileAppWalletTypeApiModel } from './mobile-app-wallet-type';

/**
 * Wallet details
 */
export interface PaymentWalletApiModel {
  /**
   * Wallet support add card by payment (optional)
   */
  add_card_by_payment?: boolean;
  /**
   * Wallet support add card stand-alone operation (optional)
   */
  add_card_stand_alone?: boolean;
  /**
   * Wallet payment by ApplePay allowed (optional)
   */
  apple_pay_allowed?: boolean;
  /**
   * Wallet authorize payment (hold funds and later capture) allowed (optional)
   */
  authorize_payment_allowed?: boolean;
  /**
   * Wallet cards (optional)
   */
  cards?: Array<PaymentWalletCardsApiModel>;
  /**
   * Country ISO code
   */
  country?: string;
  /**
   * Operation required customer country (optional)
   */
  customer_country_required?: boolean;
  /**
   * Operation required customer email (optional)
   */
  customer_email_required?: boolean;
  customer_fee?: PaymentWalletFeeApiModel;
  /**
   * Operation required customer name (optional)
   */
  customer_name_required?: boolean;
  /**
   * Operation required customer phone (optional)
   */
  customer_phone_required?: boolean;
  /**
   * Wallet payment by GooglePay allowed (optional)
   */
  google_pay_allowed?: boolean;
  integration_types?: Array<PaymentWalletApiModelIntegrationTypesEnum>;
  loyalty?: LoyaltyApiModel;
  minimal_amount?: PaymentWalletMinimalAmountApiModel;
  /**
   * Publick Key (optional)
   */
  pkey?: string;
  /**
   * Settings availability scopes
   */
  settings_possibility_scopes?: Array<MobileAppPaymentSettingsScopeApiModel>;
  /**
   * Split wallet by loyalties (optional, not for splitted wallets)
   */
  split_by_loyalties?: boolean;
  /**
   * Wallet status (optional)
   */
  status?: PaymentWalletApiModelStatusEnum;
  type?: MobileAppWalletTypeApiModel;
  /**
   * Wallet by Loyalties (optional, only for split_by_loyalties is true case)
   */
  wallets?: Array<PaymentWalletApiModel>;
}
export enum PaymentWalletApiModelIntegrationTypesEnum {
  Checkout = 'checkout',
  Elements = 'elements'
}
export enum PaymentWalletApiModelStatusEnum {
  Notexists = 'notexists',
  Invite = 'invite',
  Exists = 'exists',
  Error = 'error'
}
